<template>
  <div class="bg-white rounded shadow">
    <slot />
  </div>
</template>
